import { Button } from "@/components/ui/Button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/Card";
import { Textarea } from "@/components/ui/Textarea";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { fetchWithAuth } from "../../hooks/useAuth";

export const OrderObservatiiCard = ({ observatii }: { observatii: string }) => {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const [value, setValue] = useState(observatii || "");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setValue(observatii || "");
  }, [observatii]);

  const handleSave = async () => {
    if (!id) return;
    try {
      setSaving(true);
      const response = await fetchWithAuth(
        `/api/admin/orders/${id}/observatii`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ observatii: value || "" }),
        }
      );
      if (!response.ok) {
        const err = await response.json().catch(() => null);
        throw new Error(err?.message || "Eroare la salvarea observațiilor");
      }
      await queryClient.invalidateQueries({ queryKey: ["order", id] });
      toast.success("Observații salvate");
    } catch (error) {
      toast.error(error instanceof Error ? error.message : "Eroare la salvare");
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => setValue(observatii || "");

  const isDirty = (observatii || "") !== value;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Observații</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <Textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Scrie observațiile aici..."
        />
        <div className="flex gap-2 justify-end">
          <Button
            variant="outline"
            onClick={handleCancel}
            disabled={!isDirty || saving}
          >
            Anulează
          </Button>
          <Button onClick={handleSave} disabled={!isDirty || saving}>
            {saving ? "Se salvează..." : "Salvează"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
